/**
 * Created by Languagenut on 22/03/2019.
 */


import React from 'react';
import { Card, ProgressBar, Row, Col, Modal, Button, Breadcrumb } from 'react-bootstrap'
import { ExamResultsService, AssignmentServices } from '../services';
import ExamResultsStore from '../store/exam-results-store.js';
import ProductStore from '../store/product-store.js'
import ImageStore from '../store/image-store.js';
import GeneralTable from '../components/general_table.js';
import Translation from '../store/internationalization-store.js';
import AnswerReport from '../components/answer-report.js';
import Constants from '../constants.js';
import StudentGradeContent from '../components/popup/grading_popup_examtest.js';
import jsPDF from 'jspdf';
import 'jspdf-autotable'
import moment from 'moment';

export default class ExamTestsMinor extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            tab: "students",
            toggle: false,
            loading: false,
            lastSelected: undefined
        };
    }

    componentWillMount() {
        ExamResultsStore.on(Constants.GET_ACCOUNT_RESULTS, () => {

            for (var i = 0; i < ExamResultsStore.accountResults.length; i++) {
                if (this.props.match.params.studentUid == ExamResultsStore.accountResults[i].uid && this.props.match.params.testUid == ExamResultsStore.accountResults[i].test_uid) {
                    new Date(ExamResultsStore.accountResults[i].taken).toLocaleString();
                    this.setState({
                        total_time: ExamResultsStore.accountResults[i].total_time,
                        end_score: ExamResultsStore.accountResults[i].end_score,
                        test_type: ExamResultsStore.accountResults[i].test_type,
                        average_score: ExamResultsStore.accountResults[i].average,
                        taken: moment(ExamResultsStore.accountResults[i].taken).format('D MMM YYYY'),
                    });
                }
            }


        });

        ExamResultsService.getMinorResults(this.props.match.params.studentUid, this.props.match.params.testUid).then(function (response) {

            var p = [];
            for (var i = 0; i < response.examResults.length; i++) {
                response.examResults[i].skill = this.getSkill(response.examResults[i].key.game_uid);
                response.examResults[i].time = this.getCurrentTimer(response.examResults[i].time)
                response.examResults[i].passed_text = response.examResults[i].expectedPercentage <= response.examResults[i].percentage ? 'Passed' : 'Faild'
                response.examResults[i].title = Translation.get(response.examResults[i].title, response.examResults[i].title);
                p.push(response.examResults[i])
            }

            this.setState({
                loading: false,
                examResultsMinor: response.examResults,
                studentName: response.studentName,
                testUid: this.props.match.params.testUid
            })
        }.bind(this));
    }

    componentDidMount() {
        ExamResultsService.getAccountResults();
    }

    getCurrentTimer = function (currentTime) {
        var seconds = currentTime % 60;
        var minutes = Math.floor(currentTime % (60 * 60) / 60);
        var hours = Math.floor(currentTime / (60 * 60));
        return hours + "h:" + minutes + "m:" + seconds + "s";
    }

    getSchoolLogoName() {
        if (ProductStore.userData == undefined || ProductStore.userData.accountSettings == undefined 
            || ProductStore.userData.accountSettings['cefrLogo'] == undefined) {
            return "./img/logos/schools/nasshenzhen.png";
        }
        return ProductStore.userData.accountSettings['cefrLogo']
    }

    getSchoolLogo(callback) {
        function toDataURL(src, callback, outputFormat) {
            var img = new Image();
            img.crossOrigin = 'Anonymous';
            img.onload = function() {
              var canvas = document.createElement('CANVAS');
              var ctx = canvas.getContext('2d');
              var dataURL;
              canvas.height = this.naturalHeight;
              canvas.width = this.naturalWidth;
              ctx.drawImage(this, 0, 0);
              dataURL = canvas.toDataURL(outputFormat);
              callback(dataURL);
            };
            img.src = src;
            if (img.complete || img.complete === undefined) {
              img.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
              img.src = src;
            }
          }
          
          toDataURL(this.getSchoolLogoName(), callback, "image/png");

        if (ProductStore.userData == undefined || ProductStore.userData.accountSettings == undefined
            || ProductStore.userData.accountSettings['cefrAdminPassword'] == undefined) {
            return "N/A";
        }
        return ProductStore.userData.accountSettings['cefrLogo'];
    }

    textToImage(text) {
        var ctx = document.getElementById("canvasPdf");
        if (ctx == null || ctx == undefined) {
            var canvas = document.createElement('canvas');
            canvas.id = "canvasPdf";
            canvas.width = 600;
            canvas.height = 20;
            canvas.style.zIndex = 8;
            canvas.style.position = "absolute";

            var body = document.getElementsByTagName("body")[0];
            body.appendChild(canvas);
        }
        var canvas = document.getElementById('canvasPdf');
        ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.font = "15px arial";
        ctx.textAlign = "left";
        ctx.fillText(text, 0,15);
        return canvas.toDataURL();
    }

    certificate() {
        this.getSchoolLogo(function(dataUrl) {
            var doc = new jsPDF()

            doc.addImage(dataUrl, 'JPEG', 15, 5, 465 / 3, 60 / 3)
            doc.addImage(ImageStore.url, 'JPEG', 173, 5, 90 / 3, 70 / 3)
            doc.setFontSize(12)
            doc.text(15, 40, 'Student Name: ');
            doc.addImage(this.textToImage(this.state.studentName), 'JPEG', 45, 36, 150, 5);
            doc.text(15, 45, 'Date Completed: ' + this.state.taken);
            doc.text(15, 50, 'Time Taken: ' + this.getCurrentTimer(this.state.total_time));
            doc.text(15, 55, 'English Level Achieved: ' + this.state.end_score);


            doc.autoTable({
                startY: 65,
                columnStyles: {
                    passed: { halign: 'center' }, percentage: { halign: 'center' },
                    time: { halign: 'center' }, category: { halign: 'center' }
                },
                body: this.state.examResultsMinor,
                columns: [
                    { header: 'Activity Title', dataKey: 'title' },
                    { header: 'Skill', dataKey: 'skill' },
                    { header: 'Time Taken', dataKey: 'time' },
                    { header: 'Score %', dataKey: 'percentage' }
                ],
            })



            doc.save(this.props.match.params.studentUid + "," + this.props.match.params.testUid + " .pdf");
        }.bind(this));

    }

    getSkill($skill) {

        var label = '';
        switch ($skill) {
            case '1': label = 'Speaking'; break;
            case '2': label = 'Speaking'; break;
            case '3': label = 'Listening'; break;
            case '4': label = 'Listening'; break;
            case '5': label = 'Listening'; break;
            case '6': label = 'Listening'; break;
            case '7': label = 'Writing'; break;
            case '8': label = 'Reading'; break;
            case '9': label = 'Reading'; break;
            case '10': label = 'Reading'; break;
            case '11': label = 'Writing'; break;
            case '12': label = 'Writing'; break;
            case '13': label = 'Reading'; break;
            case '14': label = 'Writing'; break;
            case '15': label = 'Grammer'; break;
            case '16': label = 'Grammer'; break;
            case '17': label = 'Writing'; break;
            case '18': label = 'Sentence'; break;
            case '19': label = 'Reading'; break;
            case '200': label = 'Reading'; break;
            case '201': label = 'Reading'; break;
            case '202': label = 'Listening'; break;
            case '203': label = 'Reading'; break;
            case '204': label = 'Listening'; break;
            case '205': label = 'Listening'; break;
            case '206': label = 'Writing'; break;
            case '207': label = 'Speaking'; break;
            case '208': label = 'Speaking'; break;
            case '209': label = 'Writing'; break;
        }

        return label;

    }

    close() {
        this.setState({ openDialog: false });
    }

    render() {

        if (this.state.loading) return <ProgressBar animated now={45} />

        if (!this.state.examResultsMinor) {
            //return "";
        }

        let columns = [{
            dataField: 'title',
            text: "Activity Title",
            formatter: (cell, row) => {
                if (row.graded === "0") {
                    return <b className="hyperlink hyperlink_blue" onClick={function (row) {
                        var gradeData = [];
                        gradeData.uid = row.key.game_data_uid;
                        gradeData.game_uid = row.key.game_uid;
                        gradeData.exam_uid = row.key.exam_uid;
                        gradeData.percentage = row.percentage;
                        gradeData.comment = row.comment;
                        gradeData.audio = row.audio;
                        gradeData.file = row.file;
                        gradeData.text = row.text;
                        this.setState({ gradeData: gradeData, gradeModalShow: true });
                    }.bind(this, row)} size="sm" >{Translation.get(cell, cell)}}</b>
                } else {
                    return <b className="hyperlink hyperlink_blue" onClick={function (row) {
                        AssignmentServices.scoreSummary(row.key).then(function (response) {
                            this.userData = response.data;
                            this.reportType = response.type;
                            this.reportLanguage = response.language;
                            this.reportGameUID = response.game;
                            this.setState({ openDialog: true });
                        }.bind(this));
                    }.bind(this, row)} size="sm" >{Translation.get(cell, cell)}</b>
                }
            }
        }, {
            dataField: 'category',
            text: "Category"
        }, {
            dataField: 'game_uid',
            text: "Skill",
            formatter: (cell, row) => {

                return this.getSkill(row.key.game_uid)
            }
        }, {
            dataField: 'time',
            text: "Time Taken",
            align: 'center',
            headerAlign: 'center'
        }, {
            dataField: 'percentage',
            text: "Score",
            align: 'center',
            headerAlign: 'center',
            formatter: (cell, row) => {
                if (cell === null || cell === undefined || cell === "") {
                    return <b className="hyperlink hyperlink_blue" onClick={function (row) {
                        var gradeData = [];
                        gradeData.uid = row.key.game_data_uid;
                        gradeData.game_uid = row.key.game_uid;
                        gradeData.exam_uid = row.key.exam_uid;
                        gradeData.percentage = row.percentage;
                        gradeData.comment = row.comment;
                        gradeData.audio = row.audio;
                        gradeData.file = row.file;
                        gradeData.text = row.text;
                        this.setState({ gradeData: gradeData, gradeModalShow: true });
                    }.bind(this, row)} size="sm" >Grade Required</b>
                }
                return <span>{cell}%</span>;
            }
        }, {
            dataField: 'passed',
            text: "Passed",
            headerAlign: 'center',
            formatter: (cell, row) => {
                if (row.percentage === null || row.percentage === undefined || row.percentage === "") {
                    return "";
                }

                if (parseInt(row.expectedPercentage) <= parseInt(row.percentage)) {
                    return <center><span style={{ color: '#00FF00' }}><i class="fas fa-check"></i></span></center>;
                } else {
                    return <center><span style={{ color: '#FF0000' }}><i class="fas fa-times"></i></span></center>;
                }
            }
        }
        ];

        let gradeModalClose = () => {
            this.setState({ gradeModalShow: false });
        }

        let onSave = () => {
            ExamResultsService.getMinorResults(this.props.match.params.studentUid, this.props.match.params.testUid).then(function (response) {

                this.setState({
                    gradeModalShow: false,
                    loading: false,
                    examResultsMinor: response.examResults,
                    studentName: response.studentName,
                    testUid: this.props.match.params.testUid
                })
            }.bind(this));
        }

        return <div>
            <Breadcrumb>
                <Breadcrumb.Item href="#/examTests/list" ><b>Test Results</b></Breadcrumb.Item>
                <Breadcrumb.Item active><b>{this.state.studentName}</b></Breadcrumb.Item>
            </Breadcrumb>
            <Card body>
                <StudentGradeContent onSave={onSave} studentName="This is a student name" show={this.state.gradeModalShow} gradeData={this.state.gradeData} onHide={gradeModalClose} />
                <Modal show={this.state.openDialog} onHide={this.close.bind(this)} size="lg">
                    <Modal.Header closeButton>
                    </Modal.Header>
                    <Modal.Body>
                        <AnswerReport show={this.state.openDialog} gameUID={this.reportGameUID} language={this.reportLanguage} data={this.userData || {}} type={this.reportType || ""} />
                    </Modal.Body>
                </Modal>
                <Row>
                    <Col md={12}>
                        <Card.Title>{Translation.get(827, 'Student Name')}: {this.state.studentName}</Card.Title>
                        <b>{Translation.get(0, 'Date Completed')}: {this.state.taken}</b>
                        <br />
                        <b>{Translation.get(0, 'Time Taken')}: {this.getCurrentTimer(this.state.total_time)}</b>
                        <br />
                        <b>{Translation.get(0, 'English Level Achieved')}: {this.state.end_score}</b>
                        <br />
                        <b>{Translation.get(0, 'Test Taken')}: {this.state.test_type}</b>
                        <br />
                        <b>{Translation.get(0, 'Average Score')}: {this.state.average_score}%</b>

                    </Col>
                </Row>
                <hr></hr>
                <Row>
                    <Col md={12}>
                        <div id="table">
                            <Button onClick={this.certificate.bind(this)}>Print Certificate</Button>
                            <br /><br />
                            <GeneralTable noSearch={true} pageSize={40}
                                bordered={true} keyField='id' data={this.state.examResultsMinor || []} columns={columns} />
                        </div>
                    </Col>
                </Row>
            </Card></div>
    }
}